const getId: () => number = (() => {
  let counter = 0;
  return () => {
    counter += 1;
    return counter;
  };
})();

export { getId };
